import type {
  AIService,
  ChatOptions,
  ChatRequest,
  ChatResponse,
  ChatStreamChunk,
} from '../../ports/ai'
import { delay } from './util'

const ANSWER =
  'Gerne. Hier ist eine **formellere Fassung** des markierten Absatzes:\n\n' +
  '> Sehr geehrte Damen und Herren, wir bestätigen den Eingang Ihrer Unterlagen ' +
  'und werden diese innerhalb von fünf Werktagen abschließend prüfen.'

const REASONING = [
  '§4 nennt eine Lieferfrist von 14 Tagen.',
  '§9 verweist auf eine Frist von 3 Wochen für dieselbe Leistung.',
  'Beide Klauseln beziehen sich auf die Erstlieferung → Widerspruch.',
]

export class MockAIService implements AIService {
  constructor(private readonly latency: number) {}

  async chat(_req: ChatRequest, _opts?: ChatOptions): Promise<ChatResponse> {
    await delay(this.latency * 5)
    return {
      message: { role: 'assistant', content: ANSWER },
      usage: { inputTokens: 120, outputTokens: 64 },
      finishReason: 'stop',
    }
  }

  async *stream(req: ChatRequest, opts?: ChatOptions): AsyncIterable<ChatStreamChunk> {
    const signal = opts?.signal

    if (req.mode === 'thinking') {
      for (const line of REASONING) {
        if (signal?.aborted) return
        await delay(this.latency * 4)
        yield { type: 'reasoning', text: line + '\n' }
      }
    }

    for (const token of ANSWER.split(/(\s+)/)) {
      if (signal?.aborted) return
      await delay(this.latency)
      yield { type: 'delta', text: token }
    }

    if (req.rag) {
      yield {
        type: 'citation',
        citation: {
          documentId: 'doc_2',
          title: 'Doc2.pdf',
          snippet: 'Abschnitt 4.2',
          source: 'Doc2.pdf',
          score: 0.82,
        },
      }
    }

    yield { type: 'done', usage: { inputTokens: 120, outputTokens: 64 }, finishReason: 'stop' }
  }
}
